import { useCallback } from 'react';

import { MagistralDrugTemplateDeleteCommand } from '@dreryk/drerykweb-medicine-api';

import { PromiseVoidFunction, sortBeanAlphabetically } from '@dreryk/react-common';

import { FormsTemplates, FormsTemplateSortItemsFn } from '~libs.desktop.shared.user-templates.forms';

import { magistralDrugTemplatesTranslationKeys } from '../../../../translations';

import { MagistralDrugTemplateListItem } from './MagistralDrugTemplates.types';

const sortMagistralDrugTemplates: FormsTemplateSortItemsFn<MagistralDrugTemplateListItem> = (items, sortOrder) =>
   sortBeanAlphabetically(items, 'name', sortOrder, '');

type MagistralDrugTemplatesListProps = {
   readonly onTemplateRemoved: PromiseVoidFunction;
};

export const MagistralDrugTemplatesList = (props: MagistralDrugTemplatesListProps): JSX.Element => {
   const removeCommandCreator = useCallback((templateId) => {
      const command = new MagistralDrugTemplateDeleteCommand();
      command.id = templateId;
      return command;
   }, []);
   return (
      <FormsTemplates.List<MagistralDrugTemplateListItem>
         onTemplateRemoved={props.onTemplateRemoved}
         sortFn={sortMagistralDrugTemplates}
         removeConfirmationTitle={magistralDrugTemplatesTranslationKeys.removingTemplate}
         removeSuccessMessage={magistralDrugTemplatesTranslationKeys.templateRemovedSuccessfully}
         removeCommandCreator={removeCommandCreator}
         testId={'magistralDrugTemplates'}
      />
   );
};
